import { render } from "./BranchTerminalsTable.vue?vue&type=template&id=54303771"
import script from "./BranchTerminalsTable.vue?vue&type=script&lang=js"
export * from "./BranchTerminalsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__